<mat-dialog-content>
  <app-crm-person-search (onSectionComplete)="onSectionComplete($event)" (onBackPressed)="onCancel()" [isOrganizationPermissionRestricted]="false" [onlySSOUsers] = "onlySSOUsers"></app-crm-person-search>
</mat-dialog-content>

